import { useState } from "react";
import CloseButton from "../CloseButton";
import Pill from "./Pill";
import { dispatchCustomEvent } from "@/helpers/triggerAnalyticsEvent";

function  setURLParams() {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete("q");
  // urlParams.set("expanded","true");
  history.pushState(
    null,
    "",
    `${window.location.pathname}?expanded=true#examples`
  );
}

const ErrorComponent = ({
  thumbnail,
  iconSource,
  title,
  description,
  helper,
  showSamples,
  handlePrompt = () => {},
  onSearchSubmit = () => {}
}: {
  thumbnail: string;
  iconSource: string;
  title: string;
  description: string | JSX.Element;
  helper: string;
  showSamples?: boolean;
  handlePrompt?: (query: string) => void;
  onSearchSubmit?: (query: boolean) => void;
}) => {
  const [renderError, setRenderError] = useState(true);
  const searchTerms = [
    "Home Furnishings inspired by Mad Men",
    "Mediterranean inspired Patio Furniture",
    "Make my Basement Comfy & Cozy",
  ];

  if (renderError === false) {
    return;
  }

  const handleClick = () => {
    dispatchCustomEvent({
      dataObject: "error-block",
      dataType: "button",
      dataReason: "Joyhunt_get_more_inspiration_ideas",
    });
    setURLParams();
    onSearchSubmit(false); 
    
  };

  return (
    <div
      role="group"
      aria-label="Error"
      className="w-[90%] xs:w-[359px]  xs:h-full sm:w-[768px] sm:my-[36px] md:my-0 md:w-[978px] lg:w-[1024px] xl:w-[1360px] flex rounded-[8px] bg-white border p-[24px] shadow-[0px_4px_24px_0px_rgba(0,0,0,0.14)] mb-[24px] mx-auto relative -top-28 xs:-top-40 sm:-top-0 md:-top-2 "
    >
      <div className="inline absolute top-1 right-2">
        <CloseButton handler={() => setRenderError(false)} />
      </div>
      <div className="hidden sm:flex flex-row">
        <img
          src={thumbnail}
          className="h-[96px] w-[96px] sm:w-[192px] sm:h-[192px] mt-1 sm:rounded-[8px] flex flex-col justify-center items-center"
          alt=""
        />
        <div className="sm:ml-[24px] md:ml-[26px] mr-[46px] mt-[24px] sm:mt-0">
          <div className="flex">
            <img
              src={iconSource}
              alt=""
              height={20}
              width={20}
              className="mr-[8px] mb-[6px]"
            />
            <h2 className="max-h-[48px] max-w-[90%] xs:w-[295px] sm:h-[36px] sm:w-[468px] md:w-full text-[16px] sm:text-[24px] font-bold leading-[24px] sm:leading-[36px] text-charcoal truncate first-letter:uppercase">
              {title}
            </h2>
          </div>
          <div className="xl:h-[198px] mt-[18px] overflow-clip">
            <span className="text-[16px] leading-[24px] block">
              {description}
            </span>
            <span className="font-bold text-[#3E8529] text-[16px] leading-[24px] mt-[24px] block">
              {helper}
            </span>
            {showSamples ? (
              <div className="mt-[16px] xl:mt-[36px]">
                <span>
                  Try these ideas or{" "}
                  <button
                    onClick={handleClick}
                    className="syfclickevent font-bold text-syfGreen"
                    tabIndex={0}
                    data-object="error-block"
                    data-type="button"
                    data-reason="Joyhunt_get_more_inspiration_ideas"
                  >
                    get more inspiration.
                  </button>
                </span>
                <div className="flex flex-col md:flex-row flex-wrap mt-[16px] gap-[16px]">
                  {searchTerms.map((searchTerm) => {
                    return <Pill  handlePrompt={handlePrompt} searchTerm={searchTerm} key={searchTerm} />;
                  })}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex sm:hidden flex-col">
        <div className="flex flex-col mobile:flex-row">
          <img
            src={thumbnail}
            className="h-[96px] w-[96px] sm:w-[242px] sm:h-[242px] mt-1 sm:rounded-[8px] flex flex-col justify-center items-center"
            alt=""
          />
          <h2 className="max-w-[90%] mobile:w-[295px] ml-[16px] mt-4 text-[16px] font-bold leading-[24px] text-charcoal first-letter:uppercase">
            {title}
          </h2>
        </div>
        <div>
          <div className="mt-[18px] overflow-clip">
            <span className="text-[16px] leading-[24px] block">
              {description}
            </span>
            <span className="font-bold text-[#3E8529] text-[16px] leading-[24px] mt-[24px] block">
              {helper}
            </span>
            {showSamples ? (
              <div className="mt-[24px]">
                <span>
                  Try these ideas or{" "}
                  <button
                    onClick={handleClick}
                    className="syfclickevent font-bold text-syfGreen"
                    data-object="error-block"
                    data-type="button"
                    data-reason="Joyhunt_get_more_inspiration_ideas"
                  >
                    get more inspiration.
                  </button>
                </span>

                <div className="flex flex-col md:flex-row mt-[16px] gap-[16px]">
                  {searchTerms.map((searchTerm) => {
                    return <Pill handlePrompt={handlePrompt} searchTerm={searchTerm} key={`${searchTerm}_sm`}/>;
                  })}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;
